import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import MenuItem from '../../../shared/interfaces/menuItems.interface';
import { FlyoutService } from '../../../services/flyout.service';
import { MenuService } from '../../../services/menu.service';
import { LinkComponent } from '../../atoms/link/link.component';
import LinkType from '../../../shared/enums/link-type.enums';
import { HrefType } from '../../../shared/enums/href-type.enums';

@Component({
  selector: 'hdi-meta-bar',
  standalone: true,
  imports: [CommonModule, RouterModule, LinkComponent],
  templateUrl: './meta-bar.component.html',
  styleUrls: ['./meta-bar.component.scss'],
})
export class MetaBarComponent implements OnInit {
  @Input() metaMenu: Array<MenuItem> = [];
  @Input() mainMenu: Array<MenuItem> = [];

  protected readonly LinkType = LinkType;
  protected readonly HrefType = HrefType;

  constructor(
    private flyoutService: FlyoutService,
    private router: Router,
    private menuService: MenuService
  ) {}
  ngOnInit(): void {
    this.menuService.mainMenu$.subscribe((menu) => {
      this.mainMenu = menu;
    });
  }
}
